








import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EmptyView",
  components: {
    Heading
  }
});
